import React from 'react';
import LocationTemplate from './LocationTemplate';

const BellarthurPage: React.FC = () => {
  return (
    <LocationTemplate
      cityName="Bellarthur"
      stateName="North Carolina"
      countyName="Pitt"
      zipCodes={["27813"]}
      latitude={35.6028}
      longitude={-77.5292}
      population={195}
      historicalFact="Small incorporated town in Pitt County."
      nearbyTowns={[
        "Greenville, NC",
        "Farmville, NC",
        "Winterville, NC",
        "Fountain, NC",
        "Ayden, NC",
        "Bethel, NC",
        "Snow Hill, NC",
        "Hookerton, NC"
      ]}
    />
  );
};

export default BellarthurPage;